package br.com.vvrefeicoes.portal.domain.model

sealed interface OrgChartChange {
    data class DirectorAdded(
        val name: String,
    ) : OrgChartChange

    data class DirectorRemoved(
        val name: String,
    ) : OrgChartChange

    data class ManagerAdded(
        val name: String,
    ) : OrgChartChange

    data class ManagerRemoved(
        val name: String,
    ) : OrgChartChange

    data class ManagerRespondsTo(
        val manager: String,
        val director: String,
    ) : OrgChartChange

    data class ManagerStoppedRespondingTo(
        val manager: String,
        val director: String,
    ) : OrgChartChange

    data class ManagerRespondsToAll(
        val manager: String,
        val directors: List<String>,
    ) : OrgChartChange

    data class CompanyAdded(
        val name: String,
    ) : OrgChartChange

    data class CompanyRemoved(
        val name: String,
    ) : OrgChartChange

    data class CompanyManagedBy(
        val company: String,
        val managers: List<String>,
    ) : OrgChartChange

    data class CompanyStoppedBeingManagedBy(
        val company: String,
        val manager: String,
    ) : OrgChartChange

    data class CompanyManagedByInDirectors(
        val company: String,
        val manager: String,
        val directors: List<String>,
    ) : OrgChartChange

    data class CompanyStoppedBeingManagedByInDirectors(
        val company: String,
        val manager: String,
        val directors: List<String>,
    ) : OrgChartChange

    data class CompanyLinkedToDirectors(
        val company: String,
        val directors: List<String>,
    ) : OrgChartChange

    data class CompanyUnlinkedFromDirector(
        val company: String,
        val director: String,
    ) : OrgChartChange

    data class CompanyLinkedToOrganogram(
        val company: String,
    ) : OrgChartChange

    data class CompanyUnlinkedFromOrganogram(
        val company: String,
    ) : OrgChartChange
}
